const HisHandshakeHeart = ({ color, sx }) => {
  const strokeColor = color ?? '#708FBB';
  let _sx = sx ?? {};
  return (
    <svg style={_sx} width="32" height="29" viewBox="0 0 32 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.62 3.38051C27.8681 2.62597 26.9746 2.02728 25.9908 1.61878C25.007 1.21028 23.9523 1 22.8871 1C21.8218 1 20.7671 1.21028 19.7833 1.61878C18.7995 2.02728 17.906 2.62597 17.1541 3.38051L16 4.54958L14.8459 3.38051C14.094 2.62597 13.2005 2.02728 12.2167 1.61878C11.2329 1.21028 10.1782 1 9.11294 1C8.04771 1 6.99295 1.21028 6.00916 1.61878C5.02537 2.02728 4.13189 2.62597 3.37997 3.38051C0.202478 6.558 0.00763202 11.9238 4.00947 16.0005L16 27.9911L27.9905 16.0005C31.9924 11.9238 31.7975 6.558 28.62 3.38051Z"
        stroke={strokeColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path
        d="M15.998 4.54883L11.3068 9.25511C10.7137 9.85305 10.3809 10.6611 10.3809 11.5033C10.3809 12.3455 10.7137 13.1536 11.3068 13.7516C11.9047 14.3447 12.7128 14.6775 13.555 14.6775C14.3972 14.6775 15.2053 14.3447 15.8032 13.7516L19.1905 10.4392C20.0324 9.60626 21.1688 9.13907 22.353 9.13907C23.5373 9.13907 24.6737 9.60626 25.5155 10.4392L29.1127 14.0363"
        stroke={strokeColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M24.9937 18.9976L21.9961 16" stroke={strokeColor} stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"/>
      <path d="M20.4957 23.4918L17.498 20.4941" stroke={strokeColor} stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"/>
    </svg>
  )
}

export default HisHandshakeHeart;